"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var redux_persist_1 = require("redux-persist");
var actions_1 = require("./actions");
var server_1 = require("../../../helpers/server");
var moment = require("moment");
var initialState = {
    isLoadingWeeklyWorkDays: false,
    isFetchingWeeklyWorkDays: false,
    weekDays: [],
    requestDate: new Date('0001-01-01'),
    selectedUsers: [],
    pages: 0,
    isApproving: false,
    isUnapproving: false,
    isControlling: false,
    closedOrders: [],
    hasClosedOrders: false,
    lastWorkLogId: '',
    activities: [],
    isLoadingActivities: false,
    pageSize: undefined,
    pageIndex: undefined,
};
var WeekDaysReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(actions_1.Actions.WEEK_DAYS).request:
            return __assign(__assign({}, state), { isApproving: false, isControlling: false, pageSize: action.payload.pageSize, pageIndex: action.payload.page, isLoadingWeeklyWorkDays: true, isFetchingWeeklyWorkDays: true });
        case (0, server_1.apiActions)(actions_1.Actions.WEEK_DAYS).success:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false, isFetchingWeeklyWorkDays: false, weekDays: action.payload.data, pages: action.payload.pages, requestDate: action.payload.requestDate });
        case (0, server_1.apiActions)(actions_1.Actions.WEEK_DAYS).fail:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false, isFetchingWeeklyWorkDays: false });
        case actions_1.Actions.SET_SELECTED_USERS:
            return __assign(__assign({}, state), { selectedUsers: action.payload });
        case actions_1.Actions.ON_WORKLOG_UPDATED:
            return __assign(__assign({}, state), { weekDays: [] });
        case (0, server_1.apiActions)(actions_1.Actions.CONTROL_WEEK).request:
            return __assign(__assign({}, state), { hasClosedOrders: false, isControlling: true });
        case (0, server_1.apiActions)(actions_1.Actions.CONTROL_WEEK).success:
            return __assign(__assign({}, state), { isControlling: false });
        case (0, server_1.apiActions)(actions_1.Actions.CONTROL_WEEK).fail:
            return __assign(__assign({}, state), { isControlling: false });
        case (0, server_1.apiActions)(actions_1.Actions.CONTROL_WEEK).message:
            return __assign(__assign({}, state), { isControlling: false, hasClosedOrders: true, closedOrders: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.APPROVE_WEEK).request:
            return __assign(__assign({}, state), { hasClosedOrders: false, isApproving: true });
        case (0, server_1.apiActions)(actions_1.Actions.APPROVE_WEEK).success:
            return __assign(__assign({}, state), { isApproving: false });
        case (0, server_1.apiActions)(actions_1.Actions.APPROVE_WEEK).fail:
            return __assign(__assign({}, state), { isApproving: false });
        case (0, server_1.apiActions)(actions_1.Actions.APPROVE_WEEK).message:
            return __assign(__assign({}, state), { isApproving: false, hasClosedOrders: true, closedOrders: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.UNDO_APPROVE_WEEK).request:
            return __assign(__assign({}, state), { isUnapproving: true });
        case (0, server_1.apiActions)(actions_1.Actions.UNDO_APPROVE_WEEK).success:
            return __assign(__assign({}, state), { isUnapproving: false });
        case (0, server_1.apiActions)(actions_1.Actions.UNDO_APPROVE_WEEK).fail:
            return __assign(__assign({}, state), { isUnapproving: false });
        case (0, server_1.apiActions)(actions_1.Actions.UNDO_APPROVE_WEEK).message:
            return __assign(__assign({}, state), { isUnapproving: false, closedOrders: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_CREATE).request:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: true });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_CREATE).success:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false, weekDays: createWorkLog(state.weekDays, action.payload), lastWorkLogId: action.payload.entity._id, requestDate: action.payload.entity.created_at });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_CREATE).fail:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_UPDATE).request:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: true });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_UPDATE).success:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false, weekDays: updateWorkLog(state.weekDays, action.payload), requestDate: action.payload.entity.updated_at });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_UPDATE).fail:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_DELETE).request:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: true });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_DELETE).success:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false, weekDays: deleteWorkLog(state.weekDays, action.payload) });
        case (0, server_1.apiActions)(actions_1.Actions.WORKLOG_DELETE).fail:
            return __assign(__assign({}, state), { isLoadingWeeklyWorkDays: false });
        case (0, server_1.apiActions)(actions_1.Actions.RECALCULATE_WORKDAY).request:
        case (0, server_1.apiActions)(actions_1.Actions.ACTIVITIES).request:
            return __assign(__assign({}, state), { isLoadingActivities: true });
        case (0, server_1.apiActions)(actions_1.Actions.RECALCULATE_WORKDAY).success:
            return __assign(__assign(__assign({}, state), { isLoadingActivities: false }), action.payload);
        case (0, server_1.apiActions)(actions_1.Actions.ACTIVITIES).success:
            return __assign(__assign({}, state), { isLoadingActivities: false, activities: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.RECALCULATE_WORKDAY).fail:
        case (0, server_1.apiActions)(actions_1.Actions.ACTIVITIES).fail:
            return __assign(__assign({}, state), { isLoadingActivities: false, activities: [] });
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        default: return state;
    }
};
// Returns indexes of the week and day corresponding to the worklog
var getWeekDayIndex = function (weekDays, worklog, dayIndexCallback) {
    var result = {
        weekIndex: -1,
        dayIndex: -1,
    };
    result.weekIndex = _.findIndex(weekDays, function (weekDay) { return weekDay.user._id === worklog.owner; });
    if (result.weekIndex < 0) {
        return result;
    }
    result.dayIndex = _.findIndex(weekDays[result.weekIndex].workDays, dayIndexCallback);
    return result;
};
var createWorkLog = function (oldWeekDays, payload) {
    var worklog = payload.entity;
    var weekDays = _.cloneDeep(oldWeekDays);
    var _a = getWeekDayIndex(weekDays, worklog, function (workDay) {
        return moment(workDay.date).isSame(moment(worklog.date_worked), 'day');
    }), weekIndex = _a.weekIndex, dayIndex = _a.dayIndex;
    if (weekIndex >= 0 && dayIndex >= 0) {
        weekDays[weekIndex].workDays[dayIndex].worklogs.push(worklog);
    }
    return weekDays;
};
var updateWorkLog = function (oldWeekDays, payload) {
    var worklog = payload.entity;
    var weekDays = _.cloneDeep(oldWeekDays);
    var logIndex = -1;
    var _a = getWeekDayIndex(weekDays, worklog, function (workDay) {
        // Save worklog index to local variable for future usage
        logIndex = _.findIndex(workDay.worklogs, function (log) { return log._id === worklog._id; });
        return logIndex > -1;
    }), weekIndex = _a.weekIndex, dayIndex = _a.dayIndex;
    if (weekIndex >= 0 && dayIndex >= 0 && logIndex >= 0) {
        weekDays[weekIndex].workDays[dayIndex].worklogs[logIndex] = worklog;
    }
    return weekDays;
};
var deleteWorkLog = function (oldWeekDays, payload) {
    var worklog = payload.worklog;
    var weekDays = _.cloneDeep(oldWeekDays);
    var logIndex = -1;
    var _a = getWeekDayIndex(weekDays, worklog, function (workDay) {
        // Save worklog index to local variable for future usage
        logIndex = _.findIndex(workDay.worklogs, function (log) { return log._id === worklog._id; });
        return logIndex > -1;
    }), weekIndex = _a.weekIndex, dayIndex = _a.dayIndex;
    if (weekIndex >= 0 && dayIndex >= 0 && logIndex >= 0) {
        // Remove the worklog
        weekDays[weekIndex].workDays[dayIndex].worklogs.splice(logIndex, 1);
    }
    return weekDays;
};
exports.default = WeekDaysReducer;
